var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","position":"fixed","display":"flex","flex-direction":"column","justify-content":"center","align-items":"center"}},[_c('canvas',{ref:"canvas"}),_c('play-bar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }